<div style="width: 800px; height: 600px;" data-cy="fee-profile-update-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="fee-profile-update-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="fee-profile-update-header">
      <div class="section-header-title" data-cy="fee-profile-update-title">
        Update Profiles
      </div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 500px;" data-cy="fee-profile-update-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="fee-profile-update-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow: auto;" data-cy="fee-profile-update-loaded">

        <!--          body of modal-->
        <div style="display: flex; flex-direction: row" data-cy="fee-profile-update-body">
          <div style="flex:2" data-cy="fee-profile-update-table-container">

            <div class="section" style="display: flex; flex-direction: column; height: 480px;" data-cy="fee-profile-update-table-section">
              <div style="flex: 1; overflow: auto; flex-direction: column;" data-cy="fee-profile-update-table-wrapper">
                <tdo-table #orgTable [dataSource]="insurancePatients" [isSearchable]="false" data-cy="fee-profile-update-table">
                  <tdo-table-column displayName="Patient" propertyName="PatientName" [rowTemplate]="patientname" data-cy="fee-profile-update-patient-column">
                    <ng-template #patientname let-row>
                      <span data-cy="fee-profile-update-patient-name">{{ row.PatientName }}</span>
                    </ng-template>
                  </tdo-table-column>
                  <tdo-table-column displayName="Employer/Group" propertyName="EmployerGroup" [rowTemplate]="empgroup" data-cy="fee-profile-update-employer-column">
                    <ng-template #empgroup let-row>
                      <span data-cy="fee-profile-update-employer-group">{{ row.EmployerGroup }}</span>
                    </ng-template>
                  </tdo-table-column>
                </tdo-table>
              </div>
            </div>

          </div>
          <div style="flex:1; padding-left: 10px" data-cy="fee-profile-update-info">
            These profiles will be updated and the system will be using the new fee schedule for future work/services.
          </div>
        </div>

      </div>

    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="fee-profile-update-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="close(false)" class="tdo-button tdo-close" style="margin-right: 10px;" data-cy="fee-profile-update-cancel-button">Cancel</button>
      <button (click)="updateInsurance()" [disabled]="insurancePatients.length===0" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="fee-profile-update-update-button">Update</button>
    </div>

  </div>
</div>
